// storage.js
export default {
  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  getItem(key) {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  },
  removeItem(key) {
    localStorage.removeItem(key);
  }
};



// WEBPACK FOOTER //
// ./src/utils/storage.js